import {
  Box,
  Building,
  BarChart3,
  Compass,
  FileText,
  LayoutDashboard,
  Mail,
  ScrollText,
  Settings,
  ShoppingBag,
  Heart,
} from 'lucide-react'
import {
  myAccountCatalogPath,
  paths,
  adminOrdersPath,
} from 'src/routes/paths'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const useNavItems = () => {
  const { t } = useLocalization()

  const primaryWorkItems = [
    {
      label: t('Dashboard', 'Översikt'),
      href: paths.myAccount + paths.dashboard,
      icon: (
        <LayoutDashboard size={18} strokeWidth={2} className="shrink-0" />
      ),
    },
    {
      label: t('Requests', 'Förfrågningar'),
      href: paths.myAccount + paths.requests,
      icon: <FileText size={18} strokeWidth={2} className="shrink-0" />,
    },
    {
      label: t('Catalog', 'Katalog'),
      href: myAccountCatalogPath,
      icon: <ShoppingBag size={18} strokeWidth={2} className="shrink-0" />,
    },
    {
      label: t('Favourites', 'Favoriter'),
      href: paths.myAccount + paths.favourites,
      icon: <Heart size={18} strokeWidth={2} className="shrink-0" />,
    },
  ]

  const settingsItem = {
    label: t('Settings', 'Inställningar'),
    href: paths.myAccount + paths.settings,
    icon: <Settings size={18} strokeWidth={2} className="shrink-0" />,
  }

  const navItemsAdmin = [
    {
      label: t('Dashboard', 'Översikt'),
      href: paths.admin,
      icon: (
        <LayoutDashboard size={18} strokeWidth={2} className="shrink-0" />
      ),
    },
    {
      label: t('Company', 'Bolaget'),
      href: paths.adminCompany,
      icon: <Compass size={18} strokeWidth={2} className="shrink-0" />,
    },
    {
      label: t('Analytics', 'Analys'),
      href: paths.adminAnalytics,
      icon: <BarChart3 size={18} strokeWidth={2} className="shrink-0" />,
    },
    {
      label: t('Requests', 'Förfrågningar'),
      href: adminOrdersPath,
      icon: <FileText size={18} strokeWidth={2} className="shrink-0" />,
    },
    {
      label: t('Email', 'E-post'),
      href: paths.adminEmail,
      icon: <Mail size={18} strokeWidth={2} className="shrink-0" />,
    },
    {
      label: t('Instructions', 'Instruktioner'),
      href: paths.adminInstructions,
      icon: <ScrollText size={18} strokeWidth={2} className="shrink-0" />,
    },
    {
      label: t('Organizations', 'Organisationer'),
      href: paths.adminOrganizations,
      icon: <Building size={18} strokeWidth={2} className="shrink-0" />,
    },
    {
      label: t('Inventory', 'Inventarie'),
      href: '#',
      icon: <Box size={18} strokeWidth={2} className="shrink-0" />,
      subItems: [
        {
          label: t('Products', 'Produkter'),
          href: paths.adminProducts,
        },
        {
          label: t('Categories', 'Kategorier'),
          href: paths.adminCategories,
        },
        {
          label: t('Decorations costs', 'Dekorationskostnader'),
          href: paths.adminDecorationsCosts,
        },
        {
          label: t('Decorations info', 'Dekorationsinfo'),
          href: paths.adminDecorationsInfo,
        },
      ],
    },
    {
      label: t('Settings', 'Inställningar'),
      href: paths.myAccount + paths.settings,
      icon: <Settings size={18} strokeWidth={2} className="shrink-0" />,
    },
  ]

  const navItemsCustomer = [...primaryWorkItems, settingsItem]

  const navItems = [
    {
      label: t('Start', 'Start'),
      href: paths.home,
    },
    {
      label: t('Our products', 'Våra produkter'),
      href: paths.allProducts,
    },
    {
      label: t('Previous work', 'Tidigare arbete'),
      href: paths.previousWork,
    },
    {
      label: t('Contact', 'Kontakt'),
      href: paths.contact,
    },
  ]

  return {
    navItemsAdmin,
    navItemsCustomer,
    navItems,
  }
}
